import { createSlice } from '@reduxjs/toolkit';
import { FormData, FormStatusFilter, FormStatusTab } from './types';

export type CoiFormManagementInitialState = {
  forms: FormData[];
  selectedTab: FormStatusTab;
  currentPage: number;
  itemsPerPage: number;
  isLoading: boolean;
  searchQuery: string;
  selectedStatuses: FormStatusFilter[];
  sortColumnLabel: string | null;
  sortDirection: 'asc' | 'desc';
};

const initialState: CoiFormManagementInitialState = {
  forms: [],
  selectedTab: FormStatusTab.ACTIVE,
  currentPage: 1,
  itemsPerPage: 10,
  isLoading: false,
  searchQuery: '',
  selectedStatuses: [],
  sortColumnLabel: null,
  sortDirection: 'asc',
};

export const coiFormManagementSlice = createSlice({
  name: 'coiFormManagement',
  initialState,

  reducers: {
    formsUpdated: (state, action: { payload: FormData[] }) => {
      state.forms = action.payload;
    },
    selectedTabUpdated: (state, action: { payload: FormStatusTab }) => {
      state.selectedTab = action.payload;
      state.currentPage = 1;
    },
    currentPageUpdated: (state, action: { payload: number }) => {
      state.currentPage = action.payload;
    },
    itemsPerPageUpdated: (state, action: { payload: number }) => {
      state.itemsPerPage = action.payload;
      state.currentPage = 1;
    },
    isLoadingUpdated: (state, action: { payload: boolean }) => {
      state.isLoading = action.payload;
    },
    searchQueryUpdated: (state, action: { payload: string }) => {
      state.searchQuery = action.payload;
      state.currentPage = 1;
    },
    selectedStatusesUpdated: (
      state,
      action: { payload: FormStatusFilter[] },
    ) => {
      state.selectedStatuses = Array.isArray(action.payload)
        ? action.payload
        : [];
      state.currentPage = 1;
    },
    filtersReset: (state) => {
      state.searchQuery = '';
      state.selectedStatuses = [];
      state.currentPage = 1;
    },
    sortUpdated: (
      state,
      action: {
        payload: { columnLabel: string; direction: 'asc' | 'desc' };
      },
    ) => {
      state.sortColumnLabel = action.payload.columnLabel;
      state.sortDirection = action.payload.direction;
      state.currentPage = 1;
    },
  },
});

export const {
  formsUpdated,
  selectedTabUpdated,
  currentPageUpdated,
  itemsPerPageUpdated,
  isLoadingUpdated,
  searchQueryUpdated,
  selectedStatusesUpdated,
  filtersReset,
  sortUpdated,
} = coiFormManagementSlice.actions;

export const coiFormManagementReducer = coiFormManagementSlice.reducer;
